import { queryOptions } from '@tanstack/react-query';
import type { AdminVipPartnerPackDto } from '@upme/contracts';
import { api } from '../../app/api-client';
import { usersKey } from './queries';

/** Пакеты партнёрства юзера: сколько куплено, сколько осталось, кому выдано. */
export const vipPartnerPacksOptions = (userId: string) =>
  queryOptions({
    queryKey: [...usersKey, userId, 'vip-partner'] as const,
    queryFn: () => api.get(`admin/users/${userId}/vip-partner`).json<AdminVipPartnerPackDto[]>(),
  });
